module.exports = __webpack_public_path__ + "img/close-session.fc92adc4.svg";